// extracted by mini-css-extract-plugin
export default {"autoPlay":"AutoplayMomentsSwitch-module__autoPlay_zBKVP","label":"AutoplayMomentsSwitch-module__label_DdRMh"};